import { render, staticRenderFns } from "./NeighborhoodMaBasviva.vue?vue&type=template&id=6a69f524"
import script from "./NeighborhoodMaBasviva.vue?vue&type=script&lang=js"
export * from "./NeighborhoodMaBasviva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports